import {
  CLUB_MEMBERSHIP_LIST_REQUESTING,
  CLUB_MEMBERSHIP_OBJECT_REQUESTING,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  UPDATE_CLUB_MEMBERSHIP_ITEM_SELECTION
} from './constants';

const INITIAL_STATE = {
  data: {},
  isObjectFetching: false,
  isListFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_MEMBERSHIP_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }

    case CLUB_MEMBERSHIP_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case CLUB_MEMBERSHIP_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CLUB_MEMBERSHIPS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    case GET_CLUB_MEMBERSHIP_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case UPDATE_CLUB_MEMBERSHIP_ITEM_SELECTION: {
      const data = { ...state.data };
      data[action.payload.clubMembershipId] = {
        ...data[action.payload.clubMembershipId],
        itemSelection: action.payload.itemSelection
      };

      return {
        ...state,
        data
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getActiveAndOnHoldClubMemberships = (clubMembership) => {
  if (!clubMembership.data || Object.keys(clubMembership.data).length === 0) {
    return [];
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) =>
      clubMembership.data[id].status === 'Active' ||
      clubMembership.data[id].status === 'On Hold'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};

export const getCancelledClubMembership = (clubMembership) => {
  if (!clubMembership.data || Object.keys(clubMembership.data).length === 0) {
    return [];
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const cancelledIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'Cancelled'
  );
  return cancelledIds.map((id) => clubMembership.data[id]);
};
